import { oz } from '@weft/utils';
import { NewBillingCycleSchema } from './new-billing-cycle-schema';

export const BillingCycleInputSchema = oz
  .object(NewBillingCycleSchema.shape)
  .partial()
  .openapi('BillingCycleInput');

export type BillingCycleInput = oz.infer<typeof BillingCycleInputSchema>;